<form [formGroup]="sstAdminIdFg">
  <snelstart-ui-details-content class="left">
    <div class="row">
      <div class="col col-1">
        <p>Gekoppelde SnelStart administratie</p>
      </div>
      <div class="col-2">
        <snelstart-ui-select-form-control formControlName="administratieId"
                                          [options]="options"
                                          class="me-1 custom-input-250"
                                          (change)="saveForm()">
        </snelstart-ui-select-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-button type="primary"
                             class="me-1"
                             (change)="saveForm()"
                             (click)="getAdministration()">Administratie importeren
        </snelstart-ui-button>
      </div>
    </div>
  </snelstart-ui-details-content>
</form>
